var map = {
	"./ed/ed-attest.md": 17328,
	"./ed/ed-note.md": 14445,
	"./ed/ed-return-precautions.md": 12585,
	"./ed/ed-safe-discharge.md": 84409,
	"./examination/exam/back-exam-only.md": 79579,
	"./examination/exam/brain-death-exam-only.md": 67511,
	"./examination/exam/breast-exam-only.md": 44429,
	"./examination/exam/complete-exam-female.md": 41689,
	"./examination/exam/complete-exam-general.md": 21473,
	"./examination/exam/complete-exam-male.md": 70008,
	"./examination/exam/diabetic-foot-exam.md": 9017,
	"./examination/exam/exam-coma.md": 47023,
	"./examination/exam/eye-exam-only.md": 79121,
	"./examination/exam/female-pelvic-exam-only.md": 5842,
	"./examination/exam/icu-examination.md": 90470,
	"./examination/exam/knee-exam-only.md": 6607,
	"./examination/exam/major-trauma-physical-exam.md": 49517,
	"./examination/exam/neuro-exam-only.md": 2859,
	"./examination/exam/prostate-exam-only.md": 35024,
	"./examination/exam/psychiatric-exam-only.md": 27679,
	"./examination/exam/rectal-exam-only.md": 19307,
	"./examination/exam/ros-normal.md": 34477,
	"./examination/exam/shoulder-examination.md": 93901,
	"./examination/exam/skin-exam-only.md": 63749,
	"./examination/exam/soft-tissue-exam-only.md": 71400,
	"./examination/exam/visual-exam-only.md": 21128,
	"./examination/notes/icu-code-note.md": 65157,
	"./examination/notes/icu-crit-admit-note.md": 2730,
	"./examination/notes/icu-crit-progress-note.md": 19666,
	"./examination/notes/icu-death-discharge-summary.md": 76871,
	"./examination/notes/icu-pulm-consult-note.md": 40049,
	"./examination/notes/icu-pulm-progress-note.md": 17402,
	"./examination/notes/icu-rsbi.md": 82847,
	"./examination/notes/id-attest.md": 70938,
	"./examination/notes/id-consult-note.md": 196,
	"./examination/notes/id-progress-note.md": 66141,
	"./examination/notes/ip-admit-hpi-note.md": 42997,
	"./examination/notes/ip-advanced-care-planning.md": 9229,
	"./examination/notes/ip-death-note.md": 92282,
	"./examination/notes/ip-discharge-planning.md": 87869,
	"./examination/notes/ip-discharge-summary-note.md": 65147,
	"./examination/notes/ip-hospice-care-transition-note.md": 59769,
	"./examination/notes/ip-hospice-discharge-summary-note.md": 58599,
	"./examination/notes/ip-progress-note.md": 56793,
	"./examination/notes/ip-stanford-hp-template.md": 86686,
	"./examination/notes/neuro-exam-complete.md": 72120,
	"./examination/notes/neuro-office-note.md": 62090,
	"./examination/notes/neuro-progress-note.md": 271,
	"./examination/notes/op-antidepressant-2-week-call-note.md": 4308,
	"./examination/notes/op-clinic-hp.md": 2886,
	"./examination/notes/op-clinic-progress.md": 82001,
	"./examination/notes/op-dax-copilot-hp-note.md": 49011,
	"./examination/notes/op-diabetes-template.md": 75683,
	"./examination/notes/op-ecg-note.md": 30069,
	"./examination/notes/op-ed-noshow.md": 58847,
	"./examination/notes/op-hyperthyroidism-note.md": 46416,
	"./examination/notes/op-hypothyroidism-note.md": 19384,
	"./examination/notes/op-medicare-annual-wellness-visit-note.md": 53700,
	"./examination/notes/op-obesity-note.md": 43051,
	"./examination/notes/op-pcp-handoff-note.md": 99366,
	"./examination/notes/op-pituitary-note.md": 10013,
	"./examination/notes/op-suicide-screening-clinic-call.md": 93098,
	"./examination/notes/op-telemedicine-note.md": 84522,
	"./examination/notes/op-telephone-call-no-answer.md": 4479,
	"./examination/notes/op-telephone-call-note.md": 559,
	"./examination/notes/op-telephone-call-sleep-study.md": 30628,
	"./examination/notes/op-televisit-encounter.md": 18482,
	"./examination/notes/op-transition-of-care-note.md": 26679,
	"./examination/notes/op-wellness-visit.md": 72264,
	"./examination/proc/icu-arterial-line-note.md": 43334,
	"./examination/proc/icu-central-line-note.md": 42257,
	"./examination/proc/icu-chest-tube-insertion-note.md": 69033,
	"./examination/proc/icu-intrapleural-fibrinolytic-therapy.md": 42312,
	"./examination/proc/icu-intubation-note.md": 46338,
	"./examination/proc/icu-lumbar-puncture-note.md": 23429,
	"./examination/proc/icu-ogtube-procedure-note.md": 87367,
	"./examination/proc/icu-percutaneous-trach.md": 6767,
	"./examination/proc/icu-thoracentesis.md": 32382,
	"./examination/proc/ip-paracentesis-note.md": 60675,
	"./examination/proc/op-cgm-application.md": 23180,
	"./examination/proc/op-cryotherapy.md": 43160,
	"./examination/proc/op-incision-drainage-note.md": 79975,
	"./examination/proc/op-knee-injection-proc.md": 51388,
	"./examination/proc/op-large-joint-injection.md": 92268,
	"./examination/proc/op-medium-joint-injection.md": 94818,
	"./examination/proc/op-pap-smear.md": 99094,
	"./examination/proc/op-shave-biopsy-proc.md": 82617,
	"./examination/proc/op-skin-biopsy-proc.md": 14637,
	"./examination/proc/op-wet-mount-prep-proc.md": 46865,
	"./icu/abdominal-compartment-syndrome.md": 5297,
	"./icu/airway-intubation.md": 29002,
	"./icu/aspiration-pneumonitis-pneumonia.md": 70356,
	"./icu/beta-blocker-calcium-channel-blocker-poisoning.md": 77569,
	"./icu/brain-abscess.md": 80236,
	"./icu/brash-syndrome.md": 46243,
	"./icu/critical-care-nutrition-refeeding.md": 78373,
	"./icu/diffuse-alveolar-hemorrhage.md": 48103,
	"./icu/ecmo.md": 60907,
	"./icu/evali.md": 10086,
	"./icu/fat-embolism-syndrome.md": 87939,
	"./icu/hemophagocytic-lymphohistiocytosis.md": 85,
	"./icu/icu-analgesia-sedation.md": 68640,
	"./icu/invasive-hemodynamic-monitoring.md": 35052,
	"./icu/massive-transfusion.md": 5706,
	"./icu/mechanical-circulatory-support.md": 97458,
	"./icu/mechanical-ventilation.md": 10066,
	"./icu/methemoglobinemia.md": 91803,
	"./icu/noninvasive-respiratory-support.md": 95040,
	"./icu/pericardial-tamponade.md": 29393,
	"./icu/preeclampsia-hellp.md": 12981,
	"./icu/sodium-channel-blocker-poisoning.md": 50860,
	"./icu/spinal-epidural-abscess.md": 87930,
	"./icu/subarachnoid-hemorrhage.md": 55891,
	"./icu/torsades-de-pointes.md": 82113,
	"./icu/toxic-alcohol-poisoning.md": 15466,
	"./icu/ttp-hus.md": 87386,
	"./icu/undifferentiated-shock.md": 66363,
	"./icu/vasoactive-support.md": 1676,
	"./icu/ventilator-liberation.md": 47359,
	"./icu/wernicke-encephalopathy.md": 95207,
	"./inpatient/allergy-immunology/anaphylaxis.md": 26650,
	"./inpatient/allergy-immunology/hereditary-angioedema.md": 29032,
	"./inpatient/cardiology/acute-limb-ischemia.md": 17803,
	"./inpatient/cardiology/acute-pericarditis.md": 7402,
	"./inpatient/cardiology/aortic-aneurysm.md": 44875,
	"./inpatient/cardiology/aortic-dissection.md": 45032,
	"./inpatient/cardiology/aortic-regurgitation.md": 40695,
	"./inpatient/cardiology/aortic-stenosis.md": 11537,
	"./inpatient/cardiology/atrial-fibrillation.md": 82331,
	"./inpatient/cardiology/atrial-flutter.md": 47930,
	"./inpatient/cardiology/bradycardia.md": 65874,
	"./inpatient/cardiology/cabg-workup.md": 55020,
	"./inpatient/cardiology/cardiac-catheterization.md": 69220,
	"./inpatient/cardiology/cardiogenic-shock.md": 60521,
	"./inpatient/cardiology/carotid-stenosis.md": 30653,
	"./inpatient/cardiology/chest-pain.md": 8024,
	"./inpatient/cardiology/coronary-artery-disease.md": 31464,
	"./inpatient/cardiology/deep-vein-thrombosis.md": 96144,
	"./inpatient/cardiology/demand-ischemia.md": 11143,
	"./inpatient/cardiology/flash-pulmonary-edema.md": 66455,
	"./inpatient/cardiology/heart-failure.md": 3533,
	"./inpatient/cardiology/hypertension.md": 19008,
	"./inpatient/cardiology/hypertensive-emergency.md": 73692,
	"./inpatient/cardiology/hypotension.md": 55794,
	"./inpatient/cardiology/infective-endocarditis.md": 30613,
	"./inpatient/cardiology/mi-mechanical-complications.md": 32398,
	"./inpatient/cardiology/mi-stemi-ap.md": 69153,
	"./inpatient/cardiology/mi-stemi-educational.md": 29189,
	"./inpatient/cardiology/mitral-regurgitation.md": 84140,
	"./inpatient/cardiology/mitral-stenosis.md": 98684,
	"./inpatient/cardiology/myocarditis.md": 76774,
	"./inpatient/cardiology/nstemi.md": 9914,
	"./inpatient/cardiology/nsvt.md": 13505,
	"./inpatient/cardiology/pericardial-effusion.md": 65894,
	"./inpatient/cardiology/post-cardiac-arrest.md": 13606,
	"./inpatient/cardiology/presyncope.md": 65828,
	"./inpatient/cardiology/prosthetic-valve-dysfunction.md": 87528,
	"./inpatient/cardiology/qtc-prolongation.md": 46931,
	"./inpatient/cardiology/right-ventricular-failure.md": 96343,
	"./inpatient/cardiology/supraventricular-tachycardia.md": 86836,
	"./inpatient/cardiology/syncope.md": 99613,
	"./inpatient/cardiology/tricuspid-regurgitation.md": 31372,
	"./inpatient/cardiology/vt-storm.md": 41682,
	"./inpatient/cardiology/wide-complex-tachycardia.md": 23624,
	"./inpatient/dermatology/cellulitis-dermatology.md": 66980,
	"./inpatient/dermatology/decubitus-ulcer.md": 68716,
	"./inpatient/dermatology/dress.md": 20277,
	"./inpatient/dermatology/drug-eruption.md": 52103,
	"./inpatient/dermatology/sjs-ten.md": 50310,
	"./inpatient/endocrinology/acute-adrenal-insufficiency.md": 53869,
	"./inpatient/endocrinology/alcoholic-ketoacidosis.md": 40092,
	"./inpatient/endocrinology/diabetes-dka.md": 42647,
	"./inpatient/endocrinology/diabetes-insipidus.md": 11399,
	"./inpatient/endocrinology/diabetes-ip.md": 3878,
	"./inpatient/endocrinology/euglycemic-dka.md": 1281,
	"./inpatient/endocrinology/hhs-plan.md": 71396,
	"./inpatient/endocrinology/hypoglycemia.md": 66410,
	"./inpatient/endocrinology/insulin-drip-to-subq-transition.md": 90813,
	"./inpatient/endocrinology/myxedema-coma.md": 29240,
	"./inpatient/endocrinology/pituitary-apoplexy.md": 76653,
	"./inpatient/endocrinology/thyroid-storm.md": 22234,
	"./inpatient/ent-ophthalmology/acute-angle-closure-glaucoma.md": 36348,
	"./inpatient/ent-ophthalmology/acute-epiglottitis.md": 71446,
	"./inpatient/ent-ophthalmology/epistaxis.md": 64276,
	"./inpatient/ent-ophthalmology/orbital-cellulitis.md": 62704,
	"./inpatient/ent-ophthalmology/retinal-artery-occlusion.md": 60245,
	"./inpatient/gastroenterology/abdominal-pain.md": 3901,
	"./inpatient/gastroenterology/acetaminophen-overdose.md": 54013,
	"./inpatient/gastroenterology/acute-cholangitis.md": 37147,
	"./inpatient/gastroenterology/acute-liver-failure.md": 87321,
	"./inpatient/gastroenterology/acute-mesenteric-ischemia.md": 36495,
	"./inpatient/gastroenterology/acute-pancreatitis.md": 37093,
	"./inpatient/gastroenterology/alcoholic-hepatitis.md": 11553,
	"./inpatient/gastroenterology/alcoholic-liver-disease.md": 41427,
	"./inpatient/gastroenterology/anal-fissure.md": 65087,
	"./inpatient/gastroenterology/biliary-colic.md": 93508,
	"./inpatient/gastroenterology/bowel-prep.md": 9152,
	"./inpatient/gastroenterology/cannabis-hyperemesis.md": 99449,
	"./inpatient/gastroenterology/celiac-disease.md": 91047,
	"./inpatient/gastroenterology/cholecystitis.md": 9550,
	"./inpatient/gastroenterology/choledocholithiasis.md": 54643,
	"./inpatient/gastroenterology/cirrhosis.md": 3057,
	"./inpatient/gastroenterology/colon-cancer.md": 90037,
	"./inpatient/gastroenterology/constipation.md": 69480,
	"./inpatient/gastroenterology/crohn-disease.md": 46140,
	"./inpatient/gastroenterology/diarrhea-ibs.md": 79886,
	"./inpatient/gastroenterology/diarrhea.md": 35899,
	"./inpatient/gastroenterology/diverticulitis.md": 62919,
	"./inpatient/gastroenterology/dysphagia.md": 53485,
	"./inpatient/gastroenterology/gastritis.md": 51337,
	"./inpatient/gastroenterology/gastroenteritis.md": 78568,
	"./inpatient/gastroenterology/gerd.md": 1049,
	"./inpatient/gastroenterology/gi-bleed.md": 30250,
	"./inpatient/gastroenterology/hcv-screening.md": 10719,
	"./inpatient/gastroenterology/hematochezia.md": 53857,
	"./inpatient/gastroenterology/hemorrhoids-external.md": 73435,
	"./inpatient/gastroenterology/hepatic-encephalopathy.md": 7055,
	"./inpatient/gastroenterology/hepatitis-b.md": 7789,
	"./inpatient/gastroenterology/hepatitis-c.md": 81166,
	"./inpatient/gastroenterology/hepatocellular-carcinoma.md": 50358,
	"./inpatient/gastroenterology/hepatorenal-syndrome.md": 41226,
	"./inpatient/gastroenterology/hernia.md": 47038,
	"./inpatient/gastroenterology/ileus.md": 93099,
	"./inpatient/gastroenterology/liver-dysfunction.md": 27970,
	"./inpatient/gastroenterology/malabsorption.md": 26564,
	"./inpatient/gastroenterology/nausea-vomiting.md": 69496,
	"./inpatient/gastroenterology/obstructive-jaundice.md": 17347,
	"./inpatient/gastroenterology/ogilvie-syndrome.md": 16560,
	"./inpatient/gastroenterology/pancreatic-mass.md": 19932,
	"./inpatient/gastroenterology/pancreatitis.md": 56022,
	"./inpatient/gastroenterology/small-bowel-obstruction.md": 93079,
	"./inpatient/gastroenterology/spontaneous-bacterial-peritonitis.md": 29689,
	"./inpatient/gastroenterology/stercoral-colitis.md": 17488,
	"./inpatient/gastroenterology/toxic-megacolon.md": 87208,
	"./inpatient/gastroenterology/ulcerative-colitis.md": 82779,
	"./inpatient/general/carbon-monoxide-poisoning.md": 79345,
	"./inpatient/general/chronic-pain-syndrome.md": 56376,
	"./inpatient/general/medical-decision-making.md": 58497,
	"./inpatient/general/mva-trauma-hpi.md": 4530,
	"./inpatient/general/opioid-reversal.md": 8072,
	"./inpatient/general/pain.md": 475,
	"./inpatient/general/preop-evaluation.md": 76580,
	"./inpatient/general/protein-calorie-malnutrition.md": 88129,
	"./inpatient/general/salicylate-toxicity.md": 36932,
	"./inpatient/general/snake-bite.md": 25214,
	"./inpatient/general/standard-admission-orders.md": 87350,
	"./inpatient/geriatrics-palliative/advanced-care-planning.md": 59054,
	"./inpatient/geriatrics-palliative/cancer-pain.md": 89133,
	"./inpatient/geriatrics-palliative/comfort-measures-only.md": 47253,
	"./inpatient/geriatrics-palliative/elder-abuse.md": 13409,
	"./inpatient/geriatrics-palliative/failure-to-thrive.md": 13253,
	"./inpatient/geriatrics-palliative/geri-perioperative.md": 44223,
	"./inpatient/geriatrics-palliative/goals-of-care.md": 97610,
	"./inpatient/hematology-oncology/acute-chest-syndrome.md": 41869,
	"./inpatient/hematology-oncology/acute-gvhd.md": 3495,
	"./inpatient/hematology-oncology/anemia.md": 25954,
	"./inpatient/hematology-oncology/anticoagulation-reversal.md": 33892,
	"./inpatient/hematology-oncology/cytokine-release-syndrome.md": 87853,
	"./inpatient/hematology-oncology/dic.md": 54373,
	"./inpatient/hematology-oncology/elevated-inr.md": 64141,
	"./inpatient/hematology-oncology/eosinophilia.md": 53809,
	"./inpatient/hematology-oncology/heparin-induced-thrombocytopenia.md": 73791,
	"./inpatient/hematology-oncology/hyperferritinemia.md": 51888,
	"./inpatient/hematology-oncology/icans.md": 47717,
	"./inpatient/hematology-oncology/immune-related-adverse-events.md": 34211,
	"./inpatient/hematology-oncology/leucocytosis.md": 17979,
	"./inpatient/hematology-oncology/leukemia.md": 50990,
	"./inpatient/hematology-oncology/leukostasis.md": 59874,
	"./inpatient/hematology-oncology/lymphoma.md": 7932,
	"./inpatient/hematology-oncology/malignant-bowel-obstruction.md": 60603,
	"./inpatient/hematology-oncology/malignant-pleural-effusion.md": 52226,
	"./inpatient/hematology-oncology/malignant-spinal-cord-compression.md": 48962,
	"./inpatient/hematology-oncology/multiple-myeloma.md": 54506,
	"./inpatient/hematology-oncology/pancytopenia.md": 6918,
	"./inpatient/hematology-oncology/sickle-cell-crises.md": 87787,
	"./inpatient/hematology-oncology/sinusoidal-obstruction-syndrome.md": 61137,
	"./inpatient/hematology-oncology/svc-syndrome.md": 27687,
	"./inpatient/hematology-oncology/thrombocytopenia.md": 73660,
	"./inpatient/hematology-oncology/transfusion-reaction.md": 1715,
	"./inpatient/hematology-oncology/tumor-lysis-syndrome.md": 33427,
	"./inpatient/hematology-oncology/venous-thromboembolism-in-malignancy.md": 10061,
	"./inpatient/infectious-disease/arboviral-febrile-illness.md": 81496,
	"./inpatient/infectious-disease/brucellosis.md": 26674,
	"./inpatient/infectious-disease/c-difficile.md": 19182,
	"./inpatient/infectious-disease/candidemia.md": 17660,
	"./inpatient/infectious-disease/cellulitis.md": 77843,
	"./inpatient/infectious-disease/covid.md": 72806,
	"./inpatient/infectious-disease/diabetic-foot-infection.md": 30711,
	"./inpatient/infectious-disease/encephalitis.md": 42752,
	"./inpatient/infectious-disease/enteric-fever.md": 79554,
	"./inpatient/infectious-disease/febrile-transplant-recipient.md": 15784,
	"./inpatient/infectious-disease/fever-rash.md": 99420,
	"./inpatient/infectious-disease/fever-returning-traveler.md": 31268,
	"./inpatient/infectious-disease/fever-uknown-origin.md": 82743,
	"./inpatient/infectious-disease/hantavirus.md": 65426,
	"./inpatient/infectious-disease/hiv.md": 27696,
	"./inpatient/infectious-disease/influenza.md": 38193,
	"./inpatient/infectious-disease/invasive-aspergillosis.md": 49156,
	"./inpatient/infectious-disease/leptospirosis.md": 28253,
	"./inpatient/infectious-disease/malaria.md": 34652,
	"./inpatient/infectious-disease/melioidosis.md": 44550,
	"./inpatient/infectious-disease/meningitis.md": 47914,
	"./inpatient/infectious-disease/necrotizing-fasciitis.md": 2497,
	"./inpatient/infectious-disease/neurocysticercosis.md": 34545,
	"./inpatient/infectious-disease/neutropenic-fever.md": 58670,
	"./inpatient/infectious-disease/osteomyelitis.md": 6843,
	"./inpatient/infectious-disease/pneumocystis-pneumonia.md": 42833,
	"./inpatient/infectious-disease/q-fever.md": 27975,
	"./inpatient/infectious-disease/rickettsial-typhus.md": 18478,
	"./inpatient/infectious-disease/septic-arthritis.md": 24528,
	"./inpatient/infectious-disease/sirs-sepsis.md": 3116,
	"./inpatient/infectious-disease/staph-aureus-bacteremia.md": 51,
	"./inpatient/infectious-disease/strongyloidiasis.md": 61886,
	"./inpatient/infectious-disease/tick-borne-illness.md": 37320,
	"./inpatient/infectious-disease/tularemia.md": 92213,
	"./inpatient/infectious-disease/west-nile-virus.md": 52927,
	"./inpatient/musculoskeletal/back-pain.md": 15360,
	"./inpatient/musculoskeletal/fracture.md": 48282,
	"./inpatient/musculoskeletal/hip-fracture.md": 70022,
	"./inpatient/musculoskeletal/mechanical-fall.md": 3801,
	"./inpatient/nephrology-urology/acute-cystitis.md": 42565,
	"./inpatient/nephrology-urology/acute-interstitial-nephritis.md": 85492,
	"./inpatient/nephrology-urology/acute-kidney-injury.md": 51779,
	"./inpatient/nephrology-urology/acute-pyelonephritis.md": 88246,
	"./inpatient/nephrology-urology/asymptomatic-bacteriuria.md": 61439,
	"./inpatient/nephrology-urology/contrast-associated-aki.md": 11975,
	"./inpatient/nephrology-urology/esrd.md": 63590,
	"./inpatient/nephrology-urology/glomerulonephritis.md": 60270,
	"./inpatient/nephrology-urology/hypercalcemia.md": 61469,
	"./inpatient/nephrology-urology/hyperkalemia.md": 72758,
	"./inpatient/nephrology-urology/hypernatremia.md": 53039,
	"./inpatient/nephrology-urology/hypocalcemia.md": 71907,
	"./inpatient/nephrology-urology/hypokalemia.md": 87068,
	"./inpatient/nephrology-urology/hypomagnesemia.md": 88381,
	"./inpatient/nephrology-urology/hyponatremia.md": 4349,
	"./inpatient/nephrology-urology/hypophosphatemia.md": 65429,
	"./inpatient/nephrology-urology/kidney-transplant-recipient.md": 59500,
	"./inpatient/nephrology-urology/lactic-acidosis.md": 46550,
	"./inpatient/nephrology-urology/metabolic-acidosis-nongap.md": 70614,
	"./inpatient/nephrology-urology/metabolic-acidosis.md": 39458,
	"./inpatient/nephrology-urology/metabolic-alkalosis.md": 27668,
	"./inpatient/nephrology-urology/microhematuria.md": 226,
	"./inpatient/nephrology-urology/nephrolithiasis.md": 56910,
	"./inpatient/nephrology-urology/nephrotic-syndrome.md": 62378,
	"./inpatient/nephrology-urology/pd-peritonitis.md": 10155,
	"./inpatient/nephrology-urology/pyuria.md": 70054,
	"./inpatient/nephrology-urology/rhabdomyolysis.md": 69965,
	"./inpatient/nephrology-urology/urinary-retention-acute.md": 66818,
	"./inpatient/neurology/altered-mental-status.md": 37227,
	"./inpatient/neurology/brain-death.md": 62842,
	"./inpatient/neurology/brain-mass.md": 75658,
	"./inpatient/neurology/cerebral-venous-sinus-thrombosis.md": 53270,
	"./inpatient/neurology/delirium.md": 78838,
	"./inpatient/neurology/dementia.md": 38976,
	"./inpatient/neurology/essential-tremors.md": 8594,
	"./inpatient/neurology/gbs.md": 13147,
	"./inpatient/neurology/generalized-weakness.md": 15551,
	"./inpatient/neurology/headache.md": 51468,
	"./inpatient/neurology/hypoxic-brain-injury.md": 33468,
	"./inpatient/neurology/icp-management.md": 35841,
	"./inpatient/neurology/idiopathic-intracranial-hypertension.md": 27061,
	"./inpatient/neurology/intracerebral-hemorrhage.md": 30786,
	"./inpatient/neurology/myasthenia-gravis.md": 52641,
	"./inpatient/neurology/post-stroke-epilepsy.md": 80072,
	"./inpatient/neurology/pres.md": 97735,
	"./inpatient/neurology/seizure.md": 76102,
	"./inpatient/neurology/status-epilepticus.md": 10045,
	"./inpatient/neurology/stroke.md": 64025,
	"./inpatient/neurology/subdural-hematoma.md": 78012,
	"./inpatient/neurology/tbi.md": 31248,
	"./inpatient/neurology/tia.md": 91587,
	"./inpatient/neurology/vertigo.md": 51569,
	"./inpatient/psychiatry/agitation.md": 67841,
	"./inpatient/psychiatry/alcohol-withdrawal.md": 81493,
	"./inpatient/psychiatry/benzodiazepine-withdrawal.md": 17242,
	"./inpatient/psychiatry/catatonia.md": 78377,
	"./inpatient/psychiatry/extrapyramidal-symptoms.md": 19737,
	"./inpatient/psychiatry/neuroleptic-malignant-syndrome.md": 32295,
	"./inpatient/psychiatry/opioid-use-disorder.md": 61952,
	"./inpatient/psychiatry/psychosis.md": 21634,
	"./inpatient/psychiatry/stimulant-use-disorder.md": 21553,
	"./inpatient/psychiatry/substance-use-disorder.md": 54060,
	"./inpatient/psychiatry/suicidal-ideation.md": 6725,
	"./inpatient/psychiatry/tobacco-use-disorder.md": 94855,
	"./inpatient/pulmonary-critical-care/acute-hypoxic-respiratory-failure.md": 67791,
	"./inpatient/pulmonary-critical-care/ards.md": 53882,
	"./inpatient/pulmonary-critical-care/asthma.md": 80366,
	"./inpatient/pulmonary-critical-care/bronchiectasis.md": 63899,
	"./inpatient/pulmonary-critical-care/cardiac-arrest.md": 72533,
	"./inpatient/pulmonary-critical-care/cavitary-nodule.md": 55027,
	"./inpatient/pulmonary-critical-care/copd.md": 86882,
	"./inpatient/pulmonary-critical-care/cystic-lung-disease.md": 45039,
	"./inpatient/pulmonary-critical-care/hemoptysis.md": 12251,
	"./inpatient/pulmonary-critical-care/hospital-acquired-pneumonia.md": 31034,
	"./inpatient/pulmonary-critical-care/hypercarbic-respiratory-failure.md": 15998,
	"./inpatient/pulmonary-critical-care/ild.md": 68205,
	"./inpatient/pulmonary-critical-care/lung-abscess.md": 81131,
	"./inpatient/pulmonary-critical-care/organizing-pneumonia.md": 33387,
	"./inpatient/pulmonary-critical-care/osa.md": 42847,
	"./inpatient/pulmonary-critical-care/parapneumonic-effusion.md": 52444,
	"./inpatient/pulmonary-critical-care/pleural-effusion.md": 22383,
	"./inpatient/pulmonary-critical-care/pneumonia.md": 15450,
	"./inpatient/pulmonary-critical-care/pneumothorax.md": 99268,
	"./inpatient/pulmonary-critical-care/pulmonary-embolism-pe.md": 30116,
	"./inpatient/pulmonary-critical-care/pulmonary-hypertension.md": 28900,
	"./inpatient/pulmonary-critical-care/pulmonary-nodules.md": 60026,
	"./inpatient/pulmonary-critical-care/sepsis.md": 82325,
	"./inpatient/pulmonary-critical-care/septic-shock.md": 54467,
	"./inpatient/pulmonary-critical-care/shortness-of-breath.md": 27268,
	"./inpatient/rheumatology/adult-onset-stills-disease.md": 89190,
	"./inpatient/rheumatology/giant-cell-arteritis.md": 78073,
	"./inpatient/rheumatology/gout-flare.md": 66321,
	"./inpatient/rheumatology/inflammatory-arthritis.md": 36285,
	"./inpatient/rheumatology/methotrexate-counseling.md": 92437,
	"./inpatient/rheumatology/myositis.md": 42598,
	"./inpatient/rheumatology/rheumatoid-factor-positive.md": 78053,
	"./inpatient/rheumatology/scleroderma-renal-crisis.md": 50007,
	"./inpatient/rheumatology/septic-arthritis-rheumatology.md": 96131,
	"./inpatient/rheumatology/sle-flare.md": 75080,
	"./inpatient/rheumatology/vasculitis.md": 85556,
	"./outpatient/allergy-immunology/allergic-conjunctivitis.md": 40691,
	"./outpatient/allergy-immunology/allergic-rhinitis.md": 12835,
	"./outpatient/allergy-immunology/cholinergic-urticaria.md": 40191,
	"./outpatient/allergy-immunology/food-allergy.md": 27929,
	"./outpatient/allergy-immunology/latex-allergy.md": 4406,
	"./outpatient/allergy-immunology/penicillin-allergy.md": 53087,
	"./outpatient/allergy-immunology/primary-immunodeficiency.md": 15180,
	"./outpatient/allergy-immunology/urticaria-angioedema.md": 45494,
	"./outpatient/cardiology/abdominal-aortic-aneurysm.md": 32902,
	"./outpatient/cardiology/anticoagulation-fu.md": 90983,
	"./outpatient/cardiology/aortic-stenosis.md": 80058,
	"./outpatient/cardiology/arrhythmia.md": 56760,
	"./outpatient/cardiology/atrial-fibrillation.md": 96964,
	"./outpatient/cardiology/blood-pressure-follow-up-plan.md": 70549,
	"./outpatient/cardiology/chest-pain.md": 80025,
	"./outpatient/cardiology/coronary-artery-dx.md": 37997,
	"./outpatient/cardiology/dvt.md": 27331,
	"./outpatient/cardiology/edema.md": 73019,
	"./outpatient/cardiology/heart-failure.md": 8418,
	"./outpatient/cardiology/hyperlipidemia.md": 7447,
	"./outpatient/cardiology/hypertension.md": 65705,
	"./outpatient/cardiology/palpitations.md": 7129,
	"./outpatient/cardiology/peripheral-vascular-dx.md": 1220,
	"./outpatient/cardiology/syncope.md": 68722,
	"./outpatient/cardiology/varicose-veins.md": 90137,
	"./outpatient/cardiology/warfarin.md": 33877,
	"./outpatient/dermatology/acne.md": 35694,
	"./outpatient/dermatology/actinic-keratosis.md": 56792,
	"./outpatient/dermatology/balanitis.md": 68758,
	"./outpatient/dermatology/bed-bug.md": 30195,
	"./outpatient/dermatology/bromhidrosis.md": 896,
	"./outpatient/dermatology/cheilitis.md": 27893,
	"./outpatient/dermatology/chronic-venous-stasis-dermatitis.md": 39665,
	"./outpatient/dermatology/cradle-cap.md": 96805,
	"./outpatient/dermatology/epidermal-cyst.md": 74878,
	"./outpatient/dermatology/folliculitis.md": 37936,
	"./outpatient/dermatology/fragile-nails.md": 84243,
	"./outpatient/dermatology/granuloma-annulare.md": 90894,
	"./outpatient/dermatology/hair-loss.md": 42111,
	"./outpatient/dermatology/herpes-labialis.md": 11576,
	"./outpatient/dermatology/hidradenitis.md": 97313,
	"./outpatient/dermatology/hyperhidrosis.md": 73006,
	"./outpatient/dermatology/ichthyosis-eczema.md": 73568,
	"./outpatient/dermatology/impetigo.md": 94735,
	"./outpatient/dermatology/ingrown-toenail.md": 2220,
	"./outpatient/dermatology/insect-bite.md": 89358,
	"./outpatient/dermatology/lichen-planus.md": 41278,
	"./outpatient/dermatology/melasma.md": 18659,
	"./outpatient/dermatology/onychomycosis.md": 30246,
	"./outpatient/dermatology/paronychia.md": 84859,
	"./outpatient/dermatology/psoriasis.md": 84880,
	"./outpatient/dermatology/rash.md": 68225,
	"./outpatient/dermatology/rosacea.md": 88641,
	"./outpatient/dermatology/scabies.md": 97699,
	"./outpatient/dermatology/seborrheic-dermatitis.md": 42930,
	"./outpatient/dermatology/skin-cancer.md": 29763,
	"./outpatient/dermatology/skin-lesion.md": 10201,
	"./outpatient/dermatology/tinea-versicolor.md": 62311,
	"./outpatient/dermatology/vitiligo.md": 30736,
	"./outpatient/dermatology/warts.md": 45312,
	"./outpatient/dermatology/wound-care.md": 42844,
	"./outpatient/endocrinology/adrenal-incidentaloma.md": 40870,
	"./outpatient/endocrinology/diabetes.md": 341,
	"./outpatient/endocrinology/diabetic-retinopathy.md": 67281,
	"./outpatient/endocrinology/graves-disease.md": 57481,
	"./outpatient/endocrinology/hyperparathyroidism.md": 14958,
	"./outpatient/endocrinology/hyperthyroidism.md": 7584,
	"./outpatient/endocrinology/hypogonadism.md": 33074,
	"./outpatient/endocrinology/hypopituitarism.md": 60749,
	"./outpatient/endocrinology/hypothyroidism.md": 83778,
	"./outpatient/endocrinology/obesity.md": 11449,
	"./outpatient/endocrinology/osteoporosis-osteopenia.md": 40789,
	"./outpatient/endocrinology/pituitary-adenoma.md": 7659,
	"./outpatient/endocrinology/prediabetes.md": 58326,
	"./outpatient/endocrinology/primary-hyperaldosteronism.md": 65031,
	"./outpatient/endocrinology/short-stature.md": 29853,
	"./outpatient/endocrinology/subacute-thyroiditis.md": 75667,
	"./outpatient/endocrinology/testosterone-deficiency.md": 39885,
	"./outpatient/endocrinology/thyroid-cancer.md": 33784,
	"./outpatient/endocrinology/thyroid-nodule.md": 83679,
	"./outpatient/endocrinology/vitamin-d-supplementation.md": 7176,
	"./outpatient/ent-ophthalmology/age-related-macular-degeneration.md": 29542,
	"./outpatient/ent-ophthalmology/ankyloglossia.md": 68397,
	"./outpatient/ent-ophthalmology/blepharitis.md": 49912,
	"./outpatient/ent-ophthalmology/cataracts.md": 98573,
	"./outpatient/ent-ophthalmology/cerumen-impaction.md": 6321,
	"./outpatient/ent-ophthalmology/corneal-abrasion.md": 29459,
	"./outpatient/ent-ophthalmology/dental-abscess.md": 76092,
	"./outpatient/ent-ophthalmology/ear-pain.md": 54220,
	"./outpatient/ent-ophthalmology/epistaxis.md": 33809,
	"./outpatient/ent-ophthalmology/glaucoma.md": 68658,
	"./outpatient/ent-ophthalmology/head-neck-mass.md": 34362,
	"./outpatient/ent-ophthalmology/hearing-loss.md": 55443,
	"./outpatient/ent-ophthalmology/hoarseness.md": 158,
	"./outpatient/ent-ophthalmology/infectious-conjunctivitis.md": 89671,
	"./outpatient/ent-ophthalmology/meniere-disease.md": 42271,
	"./outpatient/ent-ophthalmology/nasal-polyps.md": 61810,
	"./outpatient/ent-ophthalmology/nasal-trauma.md": 33331,
	"./outpatient/ent-ophthalmology/ophthalmology-clinic.md": 73251,
	"./outpatient/ent-ophthalmology/otitis-externa.md": 44793,
	"./outpatient/ent-ophthalmology/otitis-media.md": 54788,
	"./outpatient/ent-ophthalmology/peritonsillar-abscess.md": 64720,
	"./outpatient/ent-ophthalmology/pterygium.md": 49435,
	"./outpatient/ent-ophthalmology/retinal-detachment.md": 22224,
	"./outpatient/ent-ophthalmology/sinusitis.md": 41968,
	"./outpatient/ent-ophthalmology/sore-throat.md": 25411,
	"./outpatient/ent-ophthalmology/tinnitus.md": 84045,
	"./outpatient/ent-ophthalmology/tonsillitis.md": 6035,
	"./outpatient/ent-ophthalmology/tonsolith.md": 35099,
	"./outpatient/ent-ophthalmology/tympanic-membrane-perf.md": 48296,
	"./outpatient/ent-ophthalmology/uveitis.md": 71432,
	"./outpatient/gastroenterology/abdominal-pain.md": 72228,
	"./outpatient/gastroenterology/anal-fissure.md": 49934,
	"./outpatient/gastroenterology/barrett-esophagus.md": 52416,
	"./outpatient/gastroenterology/biliary-colic.md": 63923,
	"./outpatient/gastroenterology/celiac-disease.md": 36166,
	"./outpatient/gastroenterology/cirrhosis.md": 45810,
	"./outpatient/gastroenterology/colon-cancer.md": 47568,
	"./outpatient/gastroenterology/constipation.md": 6977,
	"./outpatient/gastroenterology/crohn-disease.md": 63111,
	"./outpatient/gastroenterology/diarrhea-ibs.md": 28215,
	"./outpatient/gastroenterology/diverticulitis.md": 69462,
	"./outpatient/gastroenterology/dysphagia.md": 90646,
	"./outpatient/gastroenterology/gastritis.md": 43042,
	"./outpatient/gastroenterology/gastroenteritis.md": 11903,
	"./outpatient/gastroenterology/gastroparesis.md": 2451,
	"./outpatient/gastroenterology/gerd.md": 75196,
	"./outpatient/gastroenterology/gi-bleed.md": 34023,
	"./outpatient/gastroenterology/hcv-screening.md": 59956,
	"./outpatient/gastroenterology/helicobacter-pylori.md": 23841,
	"./outpatient/gastroenterology/hemorrhoids-external.md": 93702,
	"./outpatient/gastroenterology/hepatitis-b.md": 37006,
	"./outpatient/gastroenterology/hepatitis-c.md": 38509,
	"./outpatient/gastroenterology/hernia.md": 25723,
	"./outpatient/gastroenterology/inflammatory-bowel-disease.md": 58904,
	"./outpatient/gastroenterology/liver-dysfunction.md": 95789,
	"./outpatient/gastroenterology/malabsorption.md": 55619,
	"./outpatient/gastroenterology/masld.md": 17175,
	"./outpatient/gastroenterology/microscopic-colitis.md": 43639,
	"./outpatient/gastroenterology/pancreatitis.md": 41527,
	"./outpatient/gastroenterology/ulcerative-colitis.md": 45690,
	"./outpatient/general/annual-physical-female.md": 94518,
	"./outpatient/general/annual-physical-male.md": 29991,
	"./outpatient/general/care-gaps.md": 88071,
	"./outpatient/general/chronic-fatigue-syndrome.md": 45394,
	"./outpatient/general/chronic-pain.md": 1513,
	"./outpatient/general/fatigue.md": 34539,
	"./outpatient/general/foreign-body.md": 15883,
	"./outpatient/general/gender-affirming-hormone-therapy.md": 29424,
	"./outpatient/general/health-maintenance.md": 10764,
	"./outpatient/general/hiccups.md": 5127,
	"./outpatient/general/immigrant-refugee-health.md": 4801,
	"./outpatient/general/intimate-partner-violence.md": 51946,
	"./outpatient/general/involuntary-weight-loss.md": 53174,
	"./outpatient/general/lgbtqia-health.md": 77369,
	"./outpatient/geriatrics-palliative/fall-elderly.md": 96416,
	"./outpatient/geriatrics-palliative/frailty.md": 43942,
	"./outpatient/geriatrics-palliative/goals-of-care.md": 40951,
	"./outpatient/geriatrics-palliative/polypharmacy-deprescribing.md": 72856,
	"./outpatient/hematology-oncology/anemia.md": 81525,
	"./outpatient/hematology-oncology/cervical-lymphadenopathy.md": 94247,
	"./outpatient/hematology-oncology/g6pd-deficiency.md": 95289,
	"./outpatient/hematology-oncology/hemophilia.md": 2594,
	"./outpatient/hematology-oncology/immune-thrombocytopenia.md": 18661,
	"./outpatient/hematology-oncology/iron-deficiency-call.md": 35533,
	"./outpatient/hematology-oncology/mgus.md": 58102,
	"./outpatient/hematology-oncology/multiple-myeloma.md": 1733,
	"./outpatient/hematology-oncology/myelodysplastic-syndrome.md": 55322,
	"./outpatient/hematology-oncology/periprocedural-anticoagulation.md": 83322,
	"./outpatient/hematology-oncology/polycythemia-vera.md": 98917,
	"./outpatient/hematology-oncology/thrombocytosis.md": 59919,
	"./outpatient/infectious-disease/abscess.md": 84794,
	"./outpatient/infectious-disease/animal-bite.md": 45021,
	"./outpatient/infectious-disease/asplenia.md": 81967,
	"./outpatient/infectious-disease/cat-scratch-disease.md": 23968,
	"./outpatient/infectious-disease/cellulitis.md": 8454,
	"./outpatient/infectious-disease/clostridioides-difficile.md": 5313,
	"./outpatient/infectious-disease/genital-herpes.md": 60966,
	"./outpatient/infectious-disease/hiv-postexposure-prophylaxis.md": 12649,
	"./outpatient/infectious-disease/hiv-preexposure-prophylaxis.md": 48268,
	"./outpatient/infectious-disease/hiv.md": 93895,
	"./outpatient/infectious-disease/latent-tb.md": 76767,
	"./outpatient/infectious-disease/leishmaniasis.md": 5222,
	"./outpatient/infectious-disease/lyme-disease.md": 14960,
	"./outpatient/infectious-disease/oral-thrush.md": 13909,
	"./outpatient/infectious-disease/ppd.md": 70656,
	"./outpatient/infectious-disease/prosthetic-joint-infection.md": 84474,
	"./outpatient/infectious-disease/schistosomiasis.md": 86795,
	"./outpatient/infectious-disease/shingles.md": 3841,
	"./outpatient/infectious-disease/sti.md": 36150,
	"./outpatient/infectious-disease/syphilis.md": 25311,
	"./outpatient/infectious-disease/toxoplasmosis.md": 78025,
	"./outpatient/infectious-disease/travel-consult.md": 36775,
	"./outpatient/infectious-disease/trichinellosis.md": 59936,
	"./outpatient/infectious-disease/tuberculosis.md": 57188,
	"./outpatient/infectious-disease/urti.md": 25382,
	"./outpatient/musculoskeletal/achilles-tendinitis.md": 32498,
	"./outpatient/musculoskeletal/ankle-pain.md": 63241,
	"./outpatient/musculoskeletal/back-pain.md": 28581,
	"./outpatient/musculoskeletal/bursitis.md": 96988,
	"./outpatient/musculoskeletal/callus-foot.md": 74704,
	"./outpatient/musculoskeletal/carpal-tunnel-syndrome.md": 34619,
	"./outpatient/musculoskeletal/club-foot.md": 36176,
	"./outpatient/musculoskeletal/dupytren-contracture.md": 21731,
	"./outpatient/musculoskeletal/elbow-pain.md": 35301,
	"./outpatient/musculoskeletal/foot-ulcer.md": 14035,
	"./outpatient/musculoskeletal/forearm-fracture.md": 88750,
	"./outpatient/musculoskeletal/ganglion-cyst.md": 52908,
	"./outpatient/musculoskeletal/hallux-valgus.md": 49082,
	"./outpatient/musculoskeletal/hamstring-sprain.md": 48136,
	"./outpatient/musculoskeletal/hip-pain.md": 39639,
	"./outpatient/musculoskeletal/knee-pain.md": 65765,
	"./outpatient/musculoskeletal/metacarpal-fracture.md": 3504,
	"./outpatient/musculoskeletal/metatarsal-fracture.md": 80530,
	"./outpatient/musculoskeletal/morton-neuroma.md": 75400,
	"./outpatient/musculoskeletal/neck-pain.md": 45845,
	"./outpatient/musculoskeletal/osteoarthritis.md": 78963,
	"./outpatient/musculoskeletal/plantar-fasciitis.md": 52387,
	"./outpatient/musculoskeletal/scoliosis.md": 67641,
	"./outpatient/musculoskeletal/shoulder-pain.md": 2852,
	"./outpatient/musculoskeletal/trigger-finger.md": 43677,
	"./outpatient/musculoskeletal/wrist-fracture.md": 32567,
	"./outpatient/musculoskeletal/wrist-pain.md": 19969,
	"./outpatient/nephrology-urology/acute-bacterial-prostatitis.md": 49092,
	"./outpatient/nephrology-urology/autosomal-dominant-polycystic-kidney-disease.md": 50411,
	"./outpatient/nephrology-urology/bladder-cancer.md": 87128,
	"./outpatient/nephrology-urology/bph.md": 29495,
	"./outpatient/nephrology-urology/ckd.md": 9591,
	"./outpatient/nephrology-urology/diabetic-kidney-disease.md": 26498,
	"./outpatient/nephrology-urology/epididymitis.md": 62363,
	"./outpatient/nephrology-urology/erectile-dysfunction.md": 43563,
	"./outpatient/nephrology-urology/hematuria.md": 85759,
	"./outpatient/nephrology-urology/intestitial-cystitis.md": 27452,
	"./outpatient/nephrology-urology/nephrotic-syndrome.md": 59835,
	"./outpatient/nephrology-urology/prostate-cancer.md": 25222,
	"./outpatient/nephrology-urology/psa.md": 19869,
	"./outpatient/nephrology-urology/pyelonephritis.md": 44780,
	"./outpatient/nephrology-urology/renal-colic.md": 95670,
	"./outpatient/nephrology-urology/scrotal-mass.md": 44312,
	"./outpatient/nephrology-urology/urinary-incontinence.md": 12219,
	"./outpatient/nephrology-urology/urinary-retention.md": 50232,
	"./outpatient/nephrology-urology/urolithiasis.md": 67223,
	"./outpatient/nephrology-urology/uti.md": 24301,
	"./outpatient/neurology/acute-vestibular-neuritis.md": 49500,
	"./outpatient/neurology/bells-palsy.md": 69874,
	"./outpatient/neurology/bppv.md": 65382,
	"./outpatient/neurology/cervical-radiculopathy.md": 22337,
	"./outpatient/neurology/concussion.md": 2914,
	"./outpatient/neurology/dementia.md": 19191,
	"./outpatient/neurology/diabetic-peripheral-neuropathy.md": 13898,
	"./outpatient/neurology/dizziness.md": 87725,
	"./outpatient/neurology/essential-tremor.md": 5260,
	"./outpatient/neurology/headache.md": 58335,
	"./outpatient/neurology/migraine.md": 84534,
	"./outpatient/neurology/mild-cognitive-impairment.md": 43388,
	"./outpatient/neurology/multiple-sclerosis.md": 93788,
	"./outpatient/neurology/narcolepsy.md": 60990,
	"./outpatient/neurology/neuropathy.md": 19129,
	"./outpatient/neurology/occipital-neuralgia.md": 3653,
	"./outpatient/neurology/paraplegia.md": 45266,
	"./outpatient/neurology/parkinsons.md": 77228,
	"./outpatient/neurology/postherpetic-neuralgia.md": 1335,
	"./outpatient/neurology/psychogenic-nonepileptic-seizures.md": 14734,
	"./outpatient/neurology/restless-leg-syndrome.md": 16754,
	"./outpatient/neurology/seizures.md": 39174,
	"./outpatient/neurology/serotonin-syndrome.md": 70675,
	"./outpatient/neurology/stroke.md": 79650,
	"./outpatient/neurology/tremor.md": 53963,
	"./outpatient/psychiatry/adhd.md": 5767,
	"./outpatient/psychiatry/alcohol-cessation.md": 37864,
	"./outpatient/psychiatry/anxiety.md": 87588,
	"./outpatient/psychiatry/bipolar.md": 21235,
	"./outpatient/psychiatry/borderline-personality-disorder.md": 2992,
	"./outpatient/psychiatry/depression.md": 77186,
	"./outpatient/psychiatry/eating-disorders.md": 83140,
	"./outpatient/psychiatry/grief.md": 6187,
	"./outpatient/psychiatry/insomnia.md": 39922,
	"./outpatient/psychiatry/intermittent-explosive-disorder.md": 99578,
	"./outpatient/psychiatry/obsessive-compulsive-disorder.md": 63676,
	"./outpatient/psychiatry/opioid-use-disorder.md": 7163,
	"./outpatient/psychiatry/panic-disorder.md": 19240,
	"./outpatient/psychiatry/polysubstance-use.md": 57398,
	"./outpatient/psychiatry/ptsd.md": 45689,
	"./outpatient/psychiatry/schizophrenia.md": 47789,
	"./outpatient/psychiatry/smoking.md": 43934,
	"./outpatient/pulmonary-critical-care/acute-bronchitis.md": 17987,
	"./outpatient/pulmonary-critical-care/asthma.md": 83405,
	"./outpatient/pulmonary-critical-care/copd.md": 36985,
	"./outpatient/pulmonary-critical-care/cough.md": 33029,
	"./outpatient/pulmonary-critical-care/dyspnea.md": 51083,
	"./outpatient/pulmonary-critical-care/hemoptysis.md": 89912,
	"./outpatient/pulmonary-critical-care/incidental-pulmonary-nodule.md": 85182,
	"./outpatient/pulmonary-critical-care/lung-cancer.md": 54904,
	"./outpatient/pulmonary-critical-care/osa.md": 62110,
	"./outpatient/pulmonary-critical-care/pneumonia.md": 73175,
	"./outpatient/pulmonary-critical-care/pulmonary-hypertension.md": 74723,
	"./outpatient/pulmonary-critical-care/sarcoidosis.md": 51520,
	"./outpatient/pulmonary-critical-care/upper-airway-cough-syndrome.md": 95874,
	"./outpatient/rheumatology/ankylosing-spondylitis.md": 52648,
	"./outpatient/rheumatology/antiphospholipid-syndrome.md": 43263,
	"./outpatient/rheumatology/arthralgia-myalgia.md": 77532,
	"./outpatient/rheumatology/fibromyalgia.md": 61390,
	"./outpatient/rheumatology/gout.md": 26101,
	"./outpatient/rheumatology/igg4-related-disease.md": 76300,
	"./outpatient/rheumatology/lupus.md": 4841,
	"./outpatient/rheumatology/polymyalgia-rheumatica.md": 19448,
	"./outpatient/rheumatology/raynauds-phenomenon.md": 76553,
	"./outpatient/rheumatology/rheumatoid-arthritis.md": 5119,
	"./outpatient/rheumatology/scleroderma.md": 15615,
	"./outpatient/rheumatology/sjogrens-syndrome.md": 35503,
	"./outpatient/womens-health/abnormal-uterine-bleeding.md": 96978,
	"./outpatient/womens-health/adnexal-mass-ovarian-cyst.md": 9151,
	"./outpatient/womens-health/amenorrhea.md": 32280,
	"./outpatient/womens-health/bartholin-cyst.md": 34899,
	"./outpatient/womens-health/breast-mass.md": 55170,
	"./outpatient/womens-health/breast-screening.md": 99192,
	"./outpatient/womens-health/cervical-cancer-screening.md": 38235,
	"./outpatient/womens-health/contraception-plan.md": 11779,
	"./outpatient/womens-health/depo-provera-note.md": 73377,
	"./outpatient/womens-health/dysmenorrhea.md": 77805,
	"./outpatient/womens-health/emergency-contraception.md": 30395,
	"./outpatient/womens-health/endometriosis.md": 55993,
	"./outpatient/womens-health/hormone-replacement-counseling.md": 3665,
	"./outpatient/womens-health/infertility.md": 22917,
	"./outpatient/womens-health/menopause.md": 64759,
	"./outpatient/womens-health/pcos.md": 45271,
	"./outpatient/womens-health/pelvic-inflammatory-disease.md": 92180,
	"./outpatient/womens-health/postpartum-depression.md": 38858,
	"./outpatient/womens-health/pregnancy-check.md": 42172,
	"./outpatient/womens-health/premenstrual-syndrome.md": 94350,
	"./outpatient/womens-health/uterine-fibroids.md": 70271,
	"./outpatient/womens-health/vaginitis.md": 88450,
	"./outpatient/womens-health/vulvar-dermatoses.md": 77912,
	"./protocols/acid-base-stepwise-approach.md": 58616,
	"./protocols/admission-criteria.md": 65240,
	"./protocols/advanced-diuresis.md": 924,
	"./protocols/altered-mental-status.md": 43179,
	"./protocols/antiarrhythmic-medications.md": 70715,
	"./protocols/autoantibody-interpretation.md": 81625,
	"./protocols/calling-a-consult.md": 23058,
	"./protocols/capacity-assessment.md": 43920,
	"./protocols/cardiac-devices-and-hemodynamic-support.md": 75685,
	"./protocols/cgm-and-glycemic-targets.md": 67335,
	"./protocols/code-blue.md": 71833,
	"./protocols/comfort-care.md": 66235,
	"./protocols/direct-admit-and-ed-transfer.md": 30842,
	"./protocols/disability-competent-care.md": 79087,
	"./protocols/discharge-checklist.md": 14820,
	"./protocols/drug-testing-interpretation.md": 7629,
	"./protocols/echocardiography-and-cardiac-testing.md": 44708,
	"./protocols/ekg-interpretation.md": 10931,
	"./protocols/empiric-antimicrobials.md": 89768,
	"./protocols/exposures-and-needle-sticks.md": 65941,
	"./protocols/fever-cross-cover.md": 22376,
	"./protocols/fluid-analysis.md": 55232,
	"./protocols/infection-control.md": 81412,
	"./protocols/inpatient-care-of-incarcerated-patients.md": 82840,
	"./protocols/inpatient-chemotherapy-regimens.md": 8890,
	"./protocols/iv-fluids-and-electrolyte-repletion.md": 9504,
	"./protocols/liver-chemistry-tests.md": 77130,
	"./protocols/mechanical-ventilation.md": 27620,
	"./protocols/medical-tourism.md": 72114,
	"./protocols/medication-reconciliation.md": 10998,
	"./protocols/nice-ng28-type-2-diabetes.md": 33754,
	"./protocols/nutrition-and-feeding.md": 29764,
	"./protocols/peripheral-smear-interpretation.md": 92811,
	"./protocols/pft-interpretation.md": 84502,
	"./protocols/pocus-basic-views.md": 19575,
	"./protocols/poison-control-followup.md": 79226,
	"./protocols/presenting-a-patient.md": 3198,
	"./protocols/radiology-basics-and-contrast.md": 90350,
	"./protocols/renally-dosed-medications.md": 99505,
	"./protocols/rheumatologic-medications.md": 95399,
	"./protocols/social-determinants.md": 82107,
	"./protocols/stress-ulcer-prophylaxis.md": 5551,
	"./protocols/thyroid-nodule-tirads.md": 22760,
	"./protocols/transfusion-medicine.md": 69864,
	"./protocols/urinalysis-interpretation.md": 13171,
	"./protocols/vasopressors-and-inotropes.md": 39821,
	"./references/clinic-referrals.md": 28911,
	"./references/epic-smartphrases.md": 90835,
	"./references/rehab-services.md": 73703,
	"./references/sgmc-phone-directory.md": 15785,
	"./references/team-contacts.md": 68819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21248;